// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6277":"0f573d84","7025":"0f573d84"}[chunkId] + ".chunk.css";
};